<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="isLoading"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.size"
      :server-items-length="count"
      :options.sync="options"
      :footer-props="{'items-per-page-options':[10,50,100]}"
      class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.created="{item}">
        <span>{{correctTime(item.created, true)}}</span>
      </template>
      <template v-slot:item.admin="{item}">
        <v-icon
          :color="checkFlag(item.request.is_admin).color"
        >
          {{checkFlag(item.request.is_admin).icon}}
        </v-icon>
      </template>
      <template v-slot:item.observer="{item}">
        <v-icon
          :color="checkFlag(item.request.is_observer).color"
        >
          {{checkFlag(item.request.is_observer).icon}}
        </v-icon>
      </template>
      <template v-slot:item.entitled="{item}">
        <div v-if="item.request.is_entitled && item.request.territory">
          <span class="font-weight-bold">Территория:</span>
          <span> {{ item.request.territory.name }}</span><br>
          <span class="font-weight-bold">Посты охраны:</span><br>
          <span  v-for="(guard_post, index) in item.request.guard_posts"
                 :key="index">
                {{guard_post.name}}
            <span v-if="index + 1 !== item.request.guard_posts.length">,</span><br>
          </span>
        </div>
        <v-icon
          v-else
          :color="checkFlag(item.request.is_entitled).color"
        >
          {{checkFlag(item.request.is_entitled).icon}}
        </v-icon>
      </template>
      <template v-slot:item.representative="{item}">
        <div v-if="item.request.is_representative">
          <span>Кол-во разовых пропусков в месяц: {{ item.request.max_user_order }}</span><br>
          <span>Кол-во разовых автомобильных пропусков в месяц: {{ item.request.max_auto_one_time }}</span><br>
          <span>Кол-во вр. автомобильных пропусков в месяц: {{ item.request.max_auto_constant }}</span><br>
        </div>
        <v-icon
          v-else
          :color="checkFlag(item.request.is_representative).color"
        >
          {{checkFlag(item.request.is_representative).icon}}
        </v-icon>
      </template>


      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="updateData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {displayDate} from "@/helper";

export default {
  name: "AdminRolesLogList",
  components: {},
  mixins: [PaginatedDataMapperMixin],
  data() {
    return {
      headers: [
        {text: "Дата изменения", value: "created", sortable: true, align: "left", width: "10%"},
        {text: "Инициатор", value: "initiator.name", sortable: true, align: "left", width: "15%"},
        {text: "Администратор", value: "admin", sortable: true, align: "center", width: "10%"},
        {text: "Наблюдатель", value: "observer", sortable: true, align: "center", width: "10%"},
        {text: "Согласующий", value: "entitled", sortable: true, align: "left", width: "25%"},
        {text: "Заявитель", value: "representative", sortable: true, align: "left", width: "30%"}
      ]
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      items: "admin/getLogRoleList",
      count: "admin/getLogRoleCount",
      isLoading: "admin/isLoadingLogRole"
    })
  },
  methods: {
    ...mapActions({
      loadLogRoleList: "admin/loadLogRoleList"
    }),
    correctTime (time, minute = true) {
      if(time !==null)
        return displayDate(time, minute)
    },
    updateData(){
      this.loadData()
    },
    loadData(url=undefined){
      this.loadLogRoleList({
        url: url,
        id: this.$route.params.idRoles,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    checkFlag(flag) {
      if (flag) return {icon: "check_circle", color: "green"}
      else return {icon: "radio_button_unchecked", color: "gray"}
    }
  },
  created() {
    this.loadData(undefined)
  }
}
</script>

<style scoped>
.removeBtnPaddingRight >>> .v-toolbar__content {
  padding-right: 0px;
}
</style>
